import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const StackIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M10.76 1.27a3 3 0 0 1 2.48 0l8.59 3.9a2 2 0 0 1 0 3.66l-8.57 3.9a3 3 0 0 1-2.5 0L2.2 8.83a2 2 0 0 1 0-3.66l8.57-3.9ZM12 3a1 1 0 0 0-.41.09L3 6.99l.01.01 8.58 3.91a1 1 0 0 0 .84 0l8.59-3.9L21 7l-8.6-3.91A1 1 0 0 0 12 3ZM1.09 17.24a1 1 0 0 1 1.32-.5l9.17 4.16a1 1 0 0 0 .83 0l9.18-4.16a1 1 0 1 1 .82 1.82l-9.17 4.16a3 3 0 0 1-2.48 0l-9.17-4.16a1 1 0 0 1-.5-1.32Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M1.09 12.24a1 1 0 0 1 1.32-.5l9.17 4.16a1 1 0 0 0 .83 0l9.18-4.16a1 1 0 0 1 .82 1.82l-9.17 4.16a3 3 0 0 1-2.48 0l-9.17-4.16a1 1 0 0 1-.5-1.32Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default StackIcon;
